export default __webpack_public_path__ + "static/media/cert-general2024-cpttm.921b6040.jpg";